import { render, staticRenderFns } from "./couponField.vue?vue&type=template&id=0ecd3120&scoped=true"
import script from "./couponField.vue?vue&type=script&lang=js"
export * from "./couponField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecd3120",
  null
  
)

export default component.exports